import React from 'react';
import { Car } from 'lucide-react';
import { Label } from '../ui/label';
import { Input } from '../ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';

export const VehicleInfoSection = ({ formData, handleChange, handleSelectChange }) => {
  return (
    <div className="border-l-4 border-blue-600 pl-6">
      <h3 className="text-2xl font-bold text-gray-900 mb-4 flex items-center gap-2">
        <Car size={24} className="text-blue-700" />
        Informations du Véhicule
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="space-y-2">
          <Label htmlFor="vehicleType" className="text-base font-semibold">Type de véhicule *</Label>
          <Select value={formData.vehicleType} onValueChange={(value) => handleSelectChange('vehicleType', value)} required>
            <SelectTrigger className="h-12">
              <SelectValue placeholder="Sélectionnez le type" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="plaque-francaise">Véhicule plaque française</SelectItem>
              <SelectItem value="plaque-etrangere">Véhicule plaque étrangère</SelectItem>
              <SelectItem value="remorque">Remorques</SelectItem>
              <SelectItem value="camion-3-5t">Camion inférieur à 3,5t</SelectItem>
              <SelectItem value="camping-car">Camping-car</SelectItem>
            </SelectContent>
          </Select>
        </div>

        <div className="space-y-2">
          <Label htmlFor="brand" className="text-base font-semibold">Marque *</Label>
          <Input
            id="brand"
            name="brand"
            value={formData.brand}
            onChange={handleChange}
            placeholder="Ex: Renault, Peugeot..."
            required
            className="h-12"
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="model" className="text-base font-semibold">Modèle *</Label>
          <Input
            id="model"
            name="model"
            value={formData.model}
            onChange={handleChange}
            placeholder="Ex: Clio, 308..."
            required
            className="h-12"
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="registration" className="text-base font-semibold">Immatriculation</Label>
          <Input
            id="registration"
            name="registration"
            value={formData.registration}
            onChange={handleChange}
            placeholder="AB-123-CD"
            className="h-12"
          />
        </div>
      </div>
    </div>
  );
};
